<template>
  <div>
    <div class="footerMain_top">
      <div class="mainWidth">
        <img src="../../static/images/topbtn.png" class="top" @click="goBack" />
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-12 col-12 footer_left">
            <img src="../../static/images/logo.png" class="logo" />
            <p>客服热线：13817251257</p>
          </div>
          <div class="col-lg-9 col-md-9 col-sm-12 col-12 footer_right">
            <ul @mouseleave="mouseLeaveParent()">
              <li v-for="(item,index) in menuList" v-if="!item.meta.hidden" @mouseenter="mouseParent(index)">
                <router-link :to="item.path">{{item.meta.name}}</router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="footerMain_bottom">
          <p>地址：上海市浦东新区新金桥路27号现代产业服务园区4号楼2楼<a href="https://beian.miit.gov.cn/" style="color:#fff;text-decoration:none;margin-right:10px;">沪ICP备13004936号-1</a>沪(浦)应急管危经许[2021]202324</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      menuList: [],
      activeIndex: 0
    };
  },
  watch: {
    '$route': function (to, from) {
      this.getParentMenu();
      if (to.path == "/FunctionalCLassroom") {
        this.$router.replace({
          name: "scientificInnovation"
        });
      }
    }
  },
  methods: {
    getParentMenu () {
      this.menuList.map((item, index) => {
        if (item.name == this.$route.meta.rouAct && !item.meta.hidden) {
          this.activeIndex = index;
          this.getNavSliderLine();
        }
      });
    },
    getNavSliderLine () {
      $(".footerMain_top .footer_right ul li").eq(this.activeIndex).addClass("active1");
    },
    mouseParent (i) {
      $(".footerMain_top .footer_right ul li").removeClass("active1");
      $(".footerMain_top .footer_right ul li").eq(i).addClass("active1");
    },
    mouseLeaveParent () {
      $(".footerMain_top .footer_right ul li").removeClass("active1");
      $(".footerMain_top .footer_right ul li").eq(this.activeIndex).addClass("active1");
    },
    jumpActeqService () {
      window.open("http://teacher.delightmom.com", "_blank");
    },
    jumpStudy () {
      window.open("https://www.delightmom.com/managementSystem/html/login.html", "_blank");
    },
    jumpParent () {
      this.$router.push({
        name: "applicationDownLoad"
      });
    },
    goBack () {
      $('body,html').animate({ scrollTop: 0 }, 100);
    }
  },
  mounted () {
    //console.log(this.$router.options.routes[0].children);
    this.menuList = this.$router.options.routes[0].children;
    this.$nextTick(() => {
      this.getParentMenu();
    });
  }
}
</script>


// WEBPACK FOOTER //
// src/components/footer.vue